<template>
  <v-card
    elevation="0"
    outlined
    dark
    class="mx-auto my-12 marger"
    min-width="550"
    max-width="550"
    :min-height="mod.photos.length.length > 0 ? 820 : 450"
  >
    <v-carousel
      v-if="mod.photos.length > 0"
      :continuous="mod.photos.length > 1"
      :cycle="mod.photos.length > 1"
      :show-arrows="mod.photos.length > 1"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      :hide-delimiters="mod.photos.length <= 1"
      height="400"
    >
      <v-carousel-item
        v-for="(img, index) in mod.photos"
        :key="index"
        @click="$emit('image-object', mod.photos)"
      >
        <img
          v-if="img.link.includes('.gif')"
          :src="img.link"
          style="width: 100%; height: auto"
          :alt="img.link"
        />
        <img
          v-else
          :src="img.link"
          style="width: 100%; height: auto; align: center"
          :alt="img.link"
        />
      </v-carousel-item>
    </v-carousel>

    <v-card-title>{{ mod.name }}</v-card-title>

    <v-card-text class="description">
      <span v-html="mod.description"></span>
    </v-card-text>

    <v-card-actions style="height: 3em">
      <v-btn
        :href="mod.videoUrl"
        v-if="mod.videoUrl !== ''"
        target="_blank"
        color="red lighten-2"
        text
      >
        <v-icon color="#C73015" style="margin-right: 3px" dark>
          mdi-youtube
        </v-icon>
        YOUTUBE
      </v-btn>
    </v-card-actions>
    <v-divider class="mx-4"></v-divider>
    <v-card-text v-if="mod.isShowPrice">
      <h3 style="color: white">Pricing</h3>
      <div
        class="price-wrapper"
        v-for="(price, index) in mod.prices"
        :key="index"
      >
        <h4 class="" v-if="price.price !== '---' && price.type === 'Source Code'">
          {{ price.type }}:
          <span
            >{{ price.promotion ? price.pricePromo : price.price }}
            <del
              v-if="price.promotion"
              style=""
              class="subtitle-1 font-weight-thin"
              >{{ price.price }}</del
            >
            <span class="sale" v-if="price.promotion"> On Sale! </span>
          </span>
        </h4>
        <!-- <p class="" v-if="price.price !== '---'">
          {{ price.sold }} Copies Sold
        </p> -->
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "Mods",
  props: {
    mod: Object,
  },
};
</script>

<style scoped>
.description {
  height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
}


.price-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.sale {
  color: #e43011;
}

.white {
  color: white !important;
}

.marger {
  margin: 0 10px;
  background-color: transparent;
  margin-bottom: 10px;
}

@media (max-width: 767px) {
  .marger {
    max-width: 325px !important;
  }
}
</style>
